import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { show } from 'redux-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Confirm from 'react-confirm-bootstrap';
import { Spinner } from '../../../components/common';
import { ButtonDelete } from '../../../components/common/buttons/actions';
import { AdvertiserApi } from '../../../api';
import { humanize } from '../../../utils/helpers/text_formatters';
import AccountsFormModal from '../../../components/advertisers/accounts/AccountsForm';
import { ButtonAdd } from '../../../components/common/buttons';


class Index extends Component {
  newResource() {
    const { dispatch } = this.props;
    dispatch(show('AccountFormModal', {
      heading: 'New Account',
      formAction: 'Create'
    }));
  }

  handleEdit(c, r) {
    const { dispatch } = this.props;

    dispatch(show('AccountFormModal', {
      website: r,
      heading: `Editing Account - ${r.name}`,
      formAction: 'Update'
    }));
  }

  handleDelete(c) {
    const { dispatch } = this.props;
    dispatch(AdvertiserApi.actions.accountDelete.post(c, (_error, success) => {
      if (success) dispatch(AdvertiserApi.actions.accounts());
    }));
  }

  renderActions(c, r) {
    return (
      <ul className="list-inline">
        <li>
          <Confirm
            onConfirm={this.handleDelete.bind(this, c)}
            body='Are you sure you want to delete this account? Note that you will be billed for the remaining balance on the account immediately.'
            confirmText='Confirm Delete'
            title={`Deleting Account - ${r.name}`}
          >
            <div><ButtonDelete /></div>
          </Confirm>
        </li>
      </ul>
    );
  }

  render() {
    const { accounts, isLoading } = this.props;
    const { data } = accounts || {};

    return (
      <div className={'wrapper wrapper-content'}>
        <div>
          <div className='ibox'>
            <div className='ibox-title'>
              <h5>Accounts</h5>
            </div>
            <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
              <Spinner />
              <div className='m-b-sm text-left'>
                <ButtonAdd
                  btnLabel='Add Account'
                  onClick={this.newResource.bind(this)}
                />
              </div>
              <BootstrapTable
                striped
                ref='AccountsTable'
                data={data || []}
              >
                <TableHeaderColumn
                  width="200"
                  dataField="name"
                  dataFormat={(c, r) => {
                    return (
                      <Link to={`/advertiser/home/accounts/${r.slug}/dashboard`}>
                        {c}
                      </Link>
                    );
                  }}
                >
                  Name
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="250"
                  dataField="website"
                  dataFormat={(c) => c}
                >
                  Website
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="150"
                  dataField="status"
                  dataFormat={(c) => humanize(c)}
                >
                  Status
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="150"
                  dataField="total_active_campaigns"
                  dataFormat={(c) => humanize(c)}
                >
                  Active Campaigns
                </TableHeaderColumn>
                <TableHeaderColumn
                  isKey
                  width="100"
                  dataField="uuid"
                  dataFormat={this.renderActions.bind(this)}
                >
                  Actions
                </TableHeaderColumn>

              </BootstrapTable>
            </div>
          </div>
          <AccountsFormModal />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { advertiser } = state;

  return { accounts: advertiser.accounts.data, isLoading: advertiser.accounts.loading };
};

export default connect(mapStateToProps)(Index);
